import React, {Component} from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

import id from "@irati/utils/id"
import ButtonBase from "@irati/ui/src/Button"

import Icon, {IconTypes} from "@irati/ui/src/Icon"

const Button = styled(ButtonBase)`
  padding: ${({theme}) => theme.spacing.one};
  min-height: ${({theme}) => theme.spacing.ten};
`

class DriverButton extends Component {
  static propTypes = {
    children: PropTypes.node,
    onClick: PropTypes.func,
    showBackArrow: PropTypes.bool
  }
  static defaultProps = {
    children: null,
    onClick: () => undefined,
    showBackArrow: false
  }

  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {
    const idNamespace = id("DriverButton", this.props)
    const {showBackArrow, children} = this.props

    return (
      <Button id={idNamespace} onClick={this.props.onClick} full>
        {showBackArrow && <Icon icon={IconTypes.arrowLeft} marginRight size={24} />}
        {children}
      </Button>
    )
  }
}

export default DriverButton
